import React from "react"

function TimeLine(props) {
    return (
        <div className="timeLineTextWrapper">
            <h1 className="timeReadOut">{props.time}</h1>
            <div className="textCard">
                <h4 className="timeLineEventText">{props.text}</h4>
            </div>

            <button className="standardButton timeLineButton" onClick={props.handleClick}>{props.buttonText}</button>
        </div>
    )
}

export default TimeLine